import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tvoed-blog-entry',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './blog-entry.component.html',
  styleUrls: ['./blog-entry.component.scss']
})
export class BlogEntryComponent {
  @Input() blogEntry!: any;
}
